import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Row, Col } from 'react-bootstrap';

import { intlModule, MetaForm } from '@chedri/base';

import { getPhoneTypeOptions, PHONE_TYPE_DEFAULT } from 'helpers/clients';

import IconLink from 'components/IconLink';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

const numberMetaId = 'Contact:EmbeddedPhoneNumber';

PhoneNumberInput.propTypes = {
  index: PropTypes.number,
  value: PropTypes.object,
  onChange: PropTypes.func,
};

PhoneNumberInput.defaultProps = {
  index: undefined,
  value: undefined,
  onChange: () => undefined,
};

function PhoneNumberInput({ index, value, submitted, onError, onChange }) {
  const messages = useSelector(intlModule.selectors.getMessages);
  const lang = useSelector(intlModule.selectors.getEditLanguage);

  const [typeOptions, setTypeOptions] = useState([]);

  const addNumber = useCallback(
    event => {
      if (event.stopPropagation) {
        event.stopPropagation();
      }
      if (event.preventDefault) {
        event.preventDefault();
      }
      if (value) {
        onChange([...value, { type: PHONE_TYPE_DEFAULT }]);
      } else {
        onChange([{ type: PHONE_TYPE_DEFAULT }]);
      }
    },
    [value, onChange]
  );

  const deleteNumber = removeIndex => {
    return event => {
      if (event.stopPropagation) {
        event.stopPropagation();
      }
      if (event.preventDefault) {
        event.preventDefault();
      }
      if (Array.isArray(value)) {
        onChange([...value.filter((_, index) => index !== removeIndex)]);
      } else {
        onChange([]);
      }
    };
  };

  useEffect(() => {
    setTypeOptions(getPhoneTypeOptions(messages));
  }, []);

  return index == null ? (
    <>
      {Array.isArray(value)
        ? value.map((entry, index) => {
            // eslint-disable-next-line react/no-array-index-key
            return <PhoneNumberInput key={index} index={index} value={value} onChange={onChange} />;
          })
        : null}
      <IconLink name="fa-plus-square" label={messages.new_number} onClick={addNumber} />
    </>
  ) : (
    <MetaForm
      metaId={numberMetaId}
      language={lang}
      source={value[index]}
      onChange={data => {
        const newValue = [...value];
        newValue[index] = data;
        onChange(newValue);
      }}
    >
      {numbersMetaContext => {
        const { getProperty, setProperty, errors } = numbersMetaContext;
        if (typeof onError === 'function') {
          onError(errors);
        }
        return (
          <>
            <div className="address-editable">
              <IconLink name="fa-minus-square" label={messages.remove_selection} onClick={deleteNumber(index)} />
            </div>
            <Row className="clearfix increased-input">
              <Col xs={4}>
                <FormAutocomplete
                  options={typeOptions}
                  type="text"
                  label={messages.type}
                  value={getProperty('type', PHONE_TYPE_DEFAULT)}
                  onChange={setProperty('type')}
                  validation={submitted && errors ? errors.type : undefined}
                />
              </Col>
              <Col xs={8}>
                <FormInput
                  type="text"
                  label={messages.number}
                  value={getProperty('number')}
                  onChange={setProperty('number')}
                  validation={submitted && errors ? errors.number : undefined}
                />
              </Col>
            </Row>
          </>
        );
      }}
    </MetaForm>
  );
}

export default PhoneNumberInput;
